import { PATHS } from '@dadohr/shared/domainTypes/routes';
import { Card, Tooltip } from '@material-ui/core';
import { ButtonWithPromise } from '../../../../../components/ButtonWithPromise';
import ENV from '../../../../../env.json';
import { Section } from '../../../../../layout/Section';
import { AppLink } from '../../../../components/AppLink';
import { ButtonContainer } from '../../../../components/ButtonContainer';
import { publishTopic } from '../../../../services/pubsub';

// Move these ids to actual env files
const FARM_ORG_ID = ENV.env.name === 'Production' ? 'U-7V7f56k' : '2YrUxKcD6';

export const PageMomentsAdmin = () => {
  return (
    <Section>
      <Card>
        <ButtonContainer>
          <AppLink
            pathname={PATHS.moments.overview}
            query={{ orgId: FARM_ORG_ID }}
          >
            Go to Template farm
          </AppLink>

          <Tooltip title="Changes in the template farm are published automatically every night. If you want to update them right away, click this button">
            <ButtonWithPromise
              pending="Publishing..."
              variant="contained"
              color="primary"
              onClick={() =>
                publishTopic({ topic: 'moments-publishFarmTemplates' })
              }
            >
              Publish Template Farm templates
            </ButtonWithPromise>
          </Tooltip>
        </ButtonContainer>
      </Card>
    </Section>
  );
};
